<h2>{{ isSidebar ? 'Popular' : 'All' }} Topics</h2>
@if (allTopicsDescription) {
    <div class="mb-6 mt-2 max-w-4xl md:px-8">
        <app-rich-text-document
            [document]="allTopicsDescription?.json"></app-rich-text-document>
    </div>
}
@if ((categories | async)?.length) {
    <div class="space-y-4">
        <div
            class="grid grid-cols-1 gap-12"
            [ngClass]="{ 'md:px-8 lg:grid-cols-2': !isSidebar }">
            @for (category of categories | async; track category) {
                <app-knowledge-category-list-item
                    [category]="category"></app-knowledge-category-list-item>
            }
        </div>
    </div>
}
